import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=4219610e&scoped=true"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"
import style0 from "./ContactForm.vue?vue&type=style&index=0&id=4219610e&prod&lang=css"
import style1 from "./ContactForm.vue?vue&type=style&index=1&id=4219610e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4219610e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiInputComponent: require('/home/node/app/components/ui/InputComponent.vue').default,UiButtonComponent: require('/home/node/app/components/ui/ButtonComponent.vue').default,EditorLink: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/editors/EditorLink.js').default,ControllerContactForm: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/ControllerContactForm.js').default,EditorImage: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/editors/EditorImage.js').default})
